/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DashboardPratiqueProDto } from './DashboardPratiqueProDto';
import {
    DashboardPratiqueProDtoFromJSON,
    DashboardPratiqueProDtoFromJSONTyped,
    DashboardPratiqueProDtoToJSON,
} from './DashboardPratiqueProDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface DashboardPratiqueProDtoPaginatedResults
 */
export interface DashboardPratiqueProDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof DashboardPratiqueProDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<DashboardPratiqueProDto>}
     * @memberof DashboardPratiqueProDtoPaginatedResults
     */
    results?: Array<DashboardPratiqueProDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof DashboardPratiqueProDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the DashboardPratiqueProDtoPaginatedResults interface.
 */
export function instanceOfDashboardPratiqueProDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DashboardPratiqueProDtoPaginatedResultsFromJSON(json: any): DashboardPratiqueProDtoPaginatedResults {
    return DashboardPratiqueProDtoPaginatedResultsFromJSONTyped(json, false);
}

export function DashboardPratiqueProDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardPratiqueProDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(DashboardPratiqueProDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function DashboardPratiqueProDtoPaginatedResultsToJSON(value?: DashboardPratiqueProDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(DashboardPratiqueProDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

